var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_shared-key.js
// module id = 4UE8
// module chunks = 1